import { jsxs as i, jsx as e } from "react/jsx-runtime";
const C = ({ size: t = 64, color: r = "currentColor", ...o }) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: `0 0 ${t} ${t}`,
    fill: "none",
    ...o,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M41.459 39.0819H22.541H6V6H58V39.0819H50.9181",
          stroke: r,
          strokeWidth: "2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M36.7134 16.7141C35.5392 15.5399 33.4717 14.7239 31.5706 14.6724M26.4277 27.857C27.5317 29.3313 29.5872 30.1713 31.5706 30.2416M31.5706 14.6724C29.3077 14.6107 27.2849 15.6341 27.2849 18.4284C27.2849 23.5713 36.7134 20.9999 36.7134 26.1427C36.7134 29.0759 34.2037 30.3359 31.5706 30.2416M31.5706 14.6724V11.5713M31.5706 30.2416V33.857",
          stroke: r,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M46.1895 58.0001C49.2173 54.9727 50.9186 50.8665 50.919 46.5848V36.6801C50.906 35.4343 50.402 34.244 49.5164 33.3678C48.6309 32.4915 47.4353 32 46.1895 32.0001C45.5675 31.9968 44.951 32.1169 44.3757 32.3534C43.8004 32.5899 43.2778 32.9382 42.8379 33.378C42.3981 33.8178 42.0498 34.3405 41.8133 34.9158C41.5768 35.4911 41.4567 36.1076 41.46 36.7296V43.8115L40.9648 44.0591C39.6924 44.6974 38.6226 45.6769 37.8748 46.8881C37.1271 48.0994 36.7309 49.4947 36.7305 50.9182V50.9182",
          stroke: r,
          strokeWidth: "2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M22.541 39.082V46.5106C22.5415 50.7923 24.2427 54.8985 27.2705 57.9258",
          stroke: r,
          strokeWidth: "2",
          strokeMiterlimit: "10"
        }
      )
    ]
  }
);
export {
  C as MoneyIcon
};
